const state = {
    selFlightSchedule: null,
    isNavFromFareUpload:null
    
};

const getters = {
    GET_SEL_FLIGHT_SCHEDULE: (state) => {
        return state.selFlightSchedule;
    },
    GET_IS_NAV_FROM_FU: (state) => {
        return state.isNavFromFareUpload;
    },
   
};


const actions = {

    CLEAR_FLIGHT_SCHEDULE_STORE: ({ commit }) => {
        commit('clearFlightScheduleStore');
    },
  
    SET_SEL_FLIGHT_SCHEDULE: ({ commit }, flightSchedule) => {

        commit('saveSelFlightSchedule', flightSchedule);

    },
    SET_IS_NAV_FRM_FU: ({ commit }, isNav) => {

        commit('saveFareUploadNav', isNav);

    },

};


const mutations = {
    clearFlightScheduleStore: (state) => {
        state.selFlightSchedule = null;
        state.isNavFromFareUpload = null;

    },

   
    
    saveSelFlightSchedule: (state, flightSchedule) => {
        
        state.selFlightSchedule=flightSchedule;
    },
    saveFareUploadNav: (state, isNav) => {
        
        state.isNavFromFareUpload=isNav;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}